/**
 * Utility functions to detect iframe context and guest mode
 */

export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top
  } catch (e) {
    // If we can't access window.top, we're likely in an iframe
    return true
  }
}

export const isGuestMode = (): boolean => {
  // Guest mode is enabled when in iframe OR explicitly set in localStorage
  return isInIframe() || localStorage.getItem('guest_mode') === 'true'
}

export const enableGuestMode = (): void => {
  localStorage.setItem('guest_mode', 'true')
}

export const disableGuestMode = (): void => {
  localStorage.removeItem('guest_mode')
}

